<template>
  <div class="tva-side-nav">
    <div
      :class="[
        'tva-side-nav-item',
        {
          active: sectionIndex === index
        }
      ]"
      v-for="(section, sectionIndex) in $ml.get('sections')"
      :key="sectionIndex"
      @click="selectedSection = index"
    >
      <a :href="'#' + section.section" v-scroll-to="'#' + section.section">
        {{ section.title }}
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: ["index"],
  data() {
    return {
      selectedSection: null
    };
  }
};
</script>
<style lang="scss" scoped>
.tva-side-nav {
  position: fixed;
  top: 0;
  left: 0;
  width: 20vw;
  height: 100vh;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 4em 0;
  &-item {
    height: 30px;
    width: 100%;
    cursor: pointer;
    &.active {
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 5px;
      }
    }
    a {
      height: 100%;
      width: 100%;
      text-decoration: none;
      color: inherit;
      display: flex;
      align-items: center;
      padding: 0.5em 3em;
    }
  }
}
</style>
